import { useCallback, useEffect, useState } from 'react';
import { midiStore } from '@/stores/midiStore';

/**
 * Hook for unified MIDI input device selection logic.
 * Keeps selected device in sync with midiStore and managerEntity.
 *
 * @param managerEntity - The MIDI manager entity (required for .changeInput)
 */
export function useMidiDeviceSelector(managerEntity: any) {
  const [selectedDeviceId, setSelectedDeviceId] = useState<string>('');

  // Sync selected device with managerEntity and midiStore
  useEffect(() => {
    if (
      managerEntity?.midiManager?.inputId &&
      midiStore.inputs.some(
        (input) => input.id === managerEntity.midiManager.inputId
      )
    ) {
      setSelectedDeviceId(managerEntity.midiManager.inputId);
    } else if (midiStore.inputs.length > 0) {
      setSelectedDeviceId(midiStore.inputs[0].id);
      managerEntity?.changeInput(midiStore.inputs[0].id);
    } else {
      setSelectedDeviceId('');
    }
  }, [managerEntity?.midiManager?.inputId, midiStore.inputs, managerEntity]);

  // Change selected device and update managerEntity
  const handleDeviceChange = useCallback(
    (deviceId: string) => {
      setSelectedDeviceId(deviceId);
      managerEntity?.changeInput(deviceId);
    },
    [managerEntity]
  );

  // Refresh MIDI device list
  const refreshMidiInputs = useCallback(() => {
    midiStore.refresh(managerEntity);
  }, [managerEntity]);

  return {
    selectedDeviceId,
    setSelectedDeviceId: handleDeviceChange,
    midiInputs: midiStore.inputs,
    refreshMidiInputs,
  };
}
